import { lazy } from "react";
import Loadable from "app/components/Loadable";
import OperationalRouteGuard from "app/components/operational-workspace/OperationalRouteGuard";

const IpPatientListPage = Loadable(
  lazy(() => import("./pages/IpPatientListPage")),
);
const IpPatientWorkspacePage = Loadable(
  lazy(() => import("./pages/IpPatientWorkspacePage")),
);
const IpConfigurationPage = Loadable(
  lazy(() => import("./pages/IpConfigurationPage")),
);
const IpAdmissionEntryPage = Loadable(
  lazy(() => import("./pages/IpAdmissionEntryPage")),
);
const IpAdmissionRequestsPage = Loadable(
  lazy(() => import("./pages/IpAdmissionRequestsPage")),
);

/**
 * Inpatient product routes (healthcare-ui).
 * Census/workspace/admit entry: INPATIENT module.
 * Configuration hub: admin/setup/billing grants (page-level gate inside IpConfigurationPage).
 */
const InpatientRoutes = [
  {
    path: "/inpatient",
    element: (
      <OperationalRouteGuard moduleId="INPATIENT">
        <IpPatientListPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/inpatient/admit",
    element: (
      <OperationalRouteGuard moduleId="INPATIENT">
        <IpAdmissionEntryPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/inpatient/admission-requests",
    element: (
      <OperationalRouteGuard moduleId="INPATIENT">
        <IpAdmissionRequestsPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/inpatient/configuration",
    element: <IpConfigurationPage />,
  },
  {
    path: "/inpatient/:admissionKey",
    element: (
      <OperationalRouteGuard moduleId="INPATIENT">
        <IpPatientWorkspacePage />
      </OperationalRouteGuard>
    ),
  },
];

export default InpatientRoutes;
